{
  "page": {
    "title": "Все сотрудники"
  },
  "subtabs": {
    "label": "Разделы сотрудников",
    "all": "Все сотрудники"
  },
  "actions": {
    "add": "Добавить сотрудника",
    "addAdmin": "Добавить админа водохранилища",
    "addMenu": "Выбрать тип добавления",
    "search": "Поиск",
    "view": "Просмотр",
    "edit": "Редактировать",
    "permissions": "Права",
    "block": "Заблокировать",
    "unblock": "Разблокировать",
    "delete": "Удалить",
    "rowMenu": "Действия"
  },
  "table": {
    "label": "Таблица сотрудников",
    "employee": "Сотрудник",
    "position": "Должность",
    "phone": "Телефон",
    "adminPanel": "Админ-панель",
    "monitoringPanel": "Панель мониторинга",
    "actions": "Действие",
    "total": "Всего: {{count}}",
    "empty": "Сотрудников нет",
    "emptyHint": "Сотрудники ещё не добавлены. Нажмите «Добавить сотрудника».",
    "noResults": "Ничего не найдено",
    "noResultsHint": "По запросу «{{q}}» сотрудники не найдены.",
    "clear": "Очистить",
    "loadError": "Не удалось загрузить данные",
    "retry": "Повторить",
    "pagination": {
      "previous": "Предыдущая страница",
      "next": "Следующая страница"
    }
  },
  "status": {
    "active": "Активен",
    "inactive": "Неактивен",
    "blocked": "Заблокирован"
  },
  "access": {
    "admin": {
      "full": "Полный (CRUD)",
      "some": "Есть доступ",
      "none": "Нет доступа"
    },
    "monitoring": {
      "full": "Полный",
      "viewOnly": "Только просмотр",
      "none": "Нет доступа",
      "parts": {
        "view": "просмотр",
        "edit": "редактирование",
        "delete": "удаление",
        "upload": "файлы"
      }
    }
  },
  "form": {
    "addTitle": "Добавить сотрудника",
    "addAdminTitle": "Добавить админа водохранилища",
    "steps": {
      "label": "Шаги",
      "general": "Общие данные",
      "permissions": "Права",
      "done": "выполнено",
      "current": "текущий шаг"
    },
    "avatar": {
      "upload": "Загрузить фото",
      "hint": "JPG или PNG, до 2 МБ",
      "uploading": "Загрузка...",
      "remove": "Удалить фото",
      "invalid": "Только JPG или PNG, до 2 МБ",
      "failed": "Не удалось загрузить фото"
    },
    "fullName": "Ф.И.О.",
    "position": "Должность",
    "phone": "Телефон",
    "reservoir": "Водохранилище",
    "login": "Логин",
    "password": "Пароль",
    "role": "Роль",
    "fullNamePlaceholder": "Имя Фамилия",
    "positionPlaceholder": "Например: Главный инженер",
    "phonePlaceholder": "+998 90 123 45 67",
    "loginPlaceholder": "imya.familiya",
    "passwordUnchanged": "••••••••••",
    "passwordHint": "После сохранения нового пароля все сессии сотрудника будут закрыты.",
    "reservoirLocked": "Другое водохранилище может выбрать только админ организации",
    "roles": {
      "tenant_member": "Сотрудник",
      "tenant_admin": "Админ водохранилища",
      "org_admin": "Админ организации",
      "platform_admin": "Главный админ"
    },
    "active": "Активный сотрудник",
    "copy": "Копировать",
    "copied": "Скопировано",
    "regenerateLogin": "Сгенерировать логин",
    "regeneratePassword": "Сгенерировать пароль",
    "showPassword": "Показать пароль",
    "hidePassword": "Скрыть пароль",
    "loginTaken": "Логин занят. Свободный вариант: {{suggestion}}",
    "useSuggestion": "Взять {{suggestion}}",
    "continue": "Продолжить",
    "back": "Назад",
    "save": "Сохранить",
    "cancel": "Отмена",
    "backLink": "Вернуться назад",
    "employeeCaption": "Сотрудник: {{name}}",
    "adminNote": "Админ водохранилища имеет полный доступ ко всем разделам — отдельные права не назначаются.",
    "selfNote": "Нельзя изменить собственный статус и роль."
  },
  "validation": {
    "required": "Заполните пустое поле",
    "min": "Введите не менее {{count}} символов",
    "max": "Не более {{count}} символов",
    "login": "Только латинские буквы, цифры и . _ -",
    "phone": "Неверный номер телефона",
    "fixErrors": "Исправьте ошибки в полях"
  },
  "toast": {
    "created": "Сотрудник добавлен",
    "createdElsewhere": "Сотрудник добавлен в «{{tenant}}»",
    "saved": "Сохранено",
    "noChanges": "Изменений нет",
    "passwordChanged": "Пароль обновлён",
    "moved": "Сотрудник переведён в «{{tenant}}»",
    "blocked": "Сотрудник заблокирован",
    "unblocked": "Сотрудник разблокирован",
    "deleted": "Сотрудник удалён",
    "error": "Произошла ошибка",
    "copied": "Скопировано",
    "copyFailed": "Не удалось скопировать",
    "exported": "Логи выгружены",
    "nothingToExport": "Нет логов для выгрузки"
  },
  "dirty": {
    "title": "Изменения не сохранены",
    "text": "Введённые данные будут потеряны.",
    "stay": "Остаться",
    "leave": "Выйти"
  },
  "detail": {
    "label": "Данные сотрудника",
    "loading": "Загрузка...",
    "tabs": {
      "label": "Разделы сотрудника",
      "logs": "Логи",
      "info": "Данные",
      "permissions": "Права"
    },
    "danger": "Опасная зона",
    "block": "Заблокировать сотрудника",
    "blockHint": "Заблокированный сотрудник не сможет войти в систему. Логи сохраняются.",
    "unblock": "Разблокировать",
    "blockedHint": "Заблокирован {{date}}",
    "blockedByHint": "Заблокирован {{date}} ({{name}})",
    "delete": "Удалить сотрудника",
    "deleteHint": "Сотрудник будет удалён из водохранилища. Логи сохраняются.",
    "confirmBlock": {
      "title": "Заблокировать сотрудника",
      "text": "«{{name}}» не сможет войти в систему. Активные сессии будут закрыты.",
      "confirm": "Заблокировать"
    },
    "confirmUnblock": {
      "title": "Разблокировать",
      "text": "«{{name}}» снова сможет войти в систему.",
      "confirm": "Разблокировать"
    },
    "confirmDelete": {
      "title": "Удалить сотрудника",
      "text": "«{{name}}» будет удалён из водохранилища. Логи сохраняются.",
      "confirm": "Удалить"
    },
    "readOnly": "Режим просмотра — нет прав на изменение.",
    "adminReadOnly": "Админа водохранилища могут изменять только админы.",
    "notFound": "Сотрудник не найден",
    "notFoundHint": "Возможно, сотрудник удалён или переведён в другое водохранилище."
  },
  "permissions": {
    "panels": {
      "admin": {
        "title": "Админ-панель",
        "subtitle": "Панель управления - права CRUD"
      },
      "monitoring": {
        "title": "Панель мониторинга",
        "subtitle": "Мониторинг - просмотр и загрузка файлов"
      }
    },
    "searchModules": "Поиск модуля",
    "searchMenus": "Поиск меню",
    "selectAll": "Отметить все",
    "clearAll": "Снять все",
    "clearSearch": "Очистить",
    "moduleCount": "Модулей: {{count}}",
    "menuCount": "Меню: {{count}}",
    "results": "Найдено: {{count}}",
    "moreModules": "Ещё модулей: {{count}} - найдите через поиск",
    "moreMenus": "Ещё меню: {{count}} - найдите через поиск",
    "noResults": "Ничего не найдено",
    "notGrantable": "У вас нет этого права",
    "expand": "{{panel}} — открыть",
    "collapse": "{{panel}} — закрыть",
    "toggle": "{{panel}} — включить",
    "beyondCeiling": "У сотрудника есть права, которых нет у вас, — изменить их нельзя.",
    "modules": {
      "devices": "Устройства",
      "device_categories": "Категории устройств",
      "device_config": "Конфигурация устройств",
      "employees": "Сотрудники",
      "connectors": "Коннекторы",
      "device_locations": "Расположение устройств",
      "device_info": "Сведения об устройствах",
      "device_calibration": "Калибровка устройств"
    },
    "menus": {
      "dashboard": "Главная панель",
      "device_config": "Конфигурация устройств",
      "device_categories": "Категории устройств",
      "documents": "Документы",
      "reports": "Отчёты",
      "sections": "Разделы",
      "charts": "Графики"
    },
    "adminActions": {
      "create": "Создание",
      "read": "Чтение",
      "update": "Изменение",
      "delete": "Удаление"
    },
    "monitoringActions": {
      "view": "Просмотр",
      "edit": "Изменение",
      "delete": "Удаление",
      "upload": "Загрузка файлов"
    }
  },
  "logs": {
    "search": "Поиск по логам",
    "filtersLabel": "Тип логов",
    "filters": {
      "all": "Все",
      "error": "Ошибки",
      "admin": "Админ-панель",
      "monitoring": "Мониторинг"
    },
    "range": "Период",
    "ranges": {
      "today": "Сегодня",
      "7d": "Последние 7 дней",
      "30d": "Последние 30 дней",
      "90d": "Последние 90 дней",
      "all": "Всё время",
      "custom": "Свой период"
    },
    "customFrom": "С",
    "customTo": "По",
    "apply": "Применить",
    "today": "СЕГОДНЯ",
    "yesterday": "ВЧЕРА",
    "entries": "Записей: {{count}}",
    "error": "Ошибка",
    "export": "Выгрузить логи",
    "loadMore": "Загрузить ещё",
    "empty": "Логи не найдены",
    "emptyHint": "За выбранный период записей нет.",
    "loadError": "Не удалось загрузить логи",
    "showDetails": "Подробнее",
    "panels": {
      "admin": "Админ-панель",
      "monitoring": "Панель мониторинга",
      "auth": "Система"
    },
    "verbs": {
      "create": "Создание",
      "update": "Изменение",
      "delete": "Удаление",
      "view": "Просмотр",
      "download": "Скачивание",
      "upload": "Загрузка файла",
      "login": "Вход",
      "logout": "Выход",
      "password": "Смена пароля",
      "block": "Блокировка",
      "unblock": "Разблокировка",
      "ack": "Подтверждение",
      "other": "Действие"
    },
    "gerunds": {
      "create": "создание",
      "update": "изменение",
      "delete": "удаление",
      "view": "просмотр",
      "download": "скачивание",
      "upload": "загрузку файла",
      "login": "вход",
      "logout": "выход",
      "password": "смену пароля",
      "block": "блокировку",
      "unblock": "разблокировку",
      "ack": "подтверждение",
      "other": "действие"
    },
    "sections": {
      "auth": "Аутентификация",
      "employees": "Сотрудники",
      "devices": "Устройства",
      "device_categories": "Категории устройств",
      "device_config": "Конфигурация устройств",
      "device_locations": "Расположение устройств",
      "device_info": "Сведения об устройствах",
      "device_calibration": "Калибровка устройств",
      "connectors": "Коннекторы",
      "dashboard": "Главная панель",
      "sections": "Разделы",
      "documents": "Документы",
      "reports": "Отчёты",
      "charts": "Графики",
      "alarm_settings": "Настройки критериев",
      "system": "Система"
    },
    "descriptions": {
      "deniedKeyword": "нет доступа",
      "denied": "{{section}}: попытка — {{action}} - нет доступа",
      "denied_permission_escalation": "Попытка выдать право, которого у него нет - нет доступа",
      "denied_role_not_assignable": "Попытка назначить недопустимую роль - нет доступа",
      "auth_login": "Вошёл в систему",
      "auth_logout": "Вышел из системы",
      "auth_password_changed": "Сменил пароль",
      "member_created_named": "Добавил сотрудника «{{name}}»",
      "member_updated_named": "Изменил данные «{{name}}»",
      "member_password": "Обновил пароль «{{name}}»",
      "member_moved": "Перевёл «{{name}}» в «{{tenant}}»",
      "member_removed_named": "Удалил сотрудника «{{name}}»",
      "member_blocked_named": "Заблокировал «{{name}}»",
      "member_unblocked_named": "Разблокировал «{{name}}»",
      "document_created_named": "Загрузил файл «{{name}}»",
      "document_updated_named": "Изменил документ «{{name}}»",
      "document_updated": "Изменил документ",
      "document_deleted_named": "Удалил документ «{{name}}»",
      "document_viewed_named": "Открыл документ «{{name}}»",
      "document_downloaded_named": "Скачал документ «{{name}}»",
      "document_folder_created_named": "Создал папку «{{name}}»",
      "document_folder_updated": "Изменил папку",
      "document_folder_deleted_named": "Удалил папку «{{name}}»",
      "dashboard_saved": "Сохранил главную панель",
      "section_created_named": "Создал раздел «{{name}}»",
      "section_deleted_named": "Удалил раздел «{{name}}»",
      "folder_saved": "Сохранил чертёж раздела",
      "chart_created_named": "Создал график «{{name}}»",
      "chart_updated": "Изменил график",
      "chart_deleted_named": "Удалил график «{{name}}»",
      "device_created_named": "Создал устройство «{{name}}»",
      "device_deleted_named": "Удалил устройство «{{name}}»",
      "device_category_created_named": "Создал категорию «{{name}}»",
      "device_location_created_named": "Создал расположение «{{name}}»",
      "alarm_acknowledged": "Подтвердил тревогу",
      "alarm_settings_updated": "Изменил настройки критериев",
      "alarm_rule_updated": "Изменил пороги показателя",
      "tenant_created": "Создал водохранилище",
      "tenant_updated": "Изменил данные водохранилища",
      "tenant_deleted": "Удалил водохранилище",
      "organization_created": "Создал организацию",
      "organization_updated": "Изменил данные организации",
      "organization_deleted": "Удалил организацию",
      "org_admin_created": "Добавил админа организации",
      "org_admin_removed": "Удалил админа организации"
    },
    "generic": {
      "create": "Создал запись",
      "create_named": "Создал «{{name}}»",
      "update": "Изменил данные",
      "update_named": "Изменил «{{name}}»",
      "delete": "Удалил запись",
      "delete_named": "Удалил «{{name}}»",
      "view": "Просмотрел",
      "view_named": "Открыл «{{name}}»",
      "download": "Скачал файл",
      "download_named": "Скачал «{{name}}»",
      "upload": "Загрузил файл",
      "upload_named": "Загрузил файл «{{name}}»",
      "login": "Вошёл в систему",
      "login_named": "Вошёл в систему",
      "logout": "Вышел из системы",
      "logout_named": "Вышел из системы",
      "password": "Сменил пароль",
      "password_named": "Сменил пароль",
      "block": "Заблокировал сотрудника",
      "block_named": "Заблокировал «{{name}}»",
      "unblock": "Разблокировал сотрудника",
      "unblock_named": "Разблокировал «{{name}}»",
      "ack": "Подтвердил",
      "ack_named": "Подтвердил «{{name}}»",
      "other": "Действие выполнено",
      "other_named": "«{{name}}»"
    },
    "details": {
      "name": "Название",
      "employee": "Сотрудник",
      "role": "Роль",
      "fields": "Изменено",
      "movedTo": "Новое водохранилище",
      "version": "Версия",
      "indicator": "Показатель",
      "level": "Уровень",
      "request": "Запрос",
      "code": "Код ошибки",
      "browser": "Браузер",
      "ip": "IP-адрес",
      "logId": "ID лога"
    },
    "fields": {
      "fullName": "Ф.И.О.",
      "position": "Должность",
      "phone": "Телефон",
      "login": "Логин",
      "isActive": "Активность",
      "avatarFileId": "Фото",
      "role": "Роль",
      "permissions": "Права",
      "tenantId": "Водохранилище",
      "name": "Название"
    },
    "csv": {
      "logId": "ID лога",
      "date": "Дата",
      "time": "Время",
      "title": "Действие",
      "description": "Описание",
      "panel": "Панель",
      "ip": "IP-адрес",
      "browser": "Браузер",
      "outcome": "Результат",
      "ok": "Успешно",
      "failed": "Ошибка"
    }
  }
}
